import styled from "styled-components";
import { PopupWrapper } from "../../../style";
import { MileagePopupWrapper } from "../../mileage/style";
import { SolutionHistoryHeader } from "../../history/style";

export const ManualPointWrapper = styled(PopupWrapper)<{ isWide: boolean }>`
  width: ${({ isWide }) => (isWide ? "514px" : "calc(100% - 32px)")};
  min-height: 366px;
  height: auto;
  border-radius: 12px;
  padding: 15px;
  box-sizing: border-box;
`;

export const ManualPointHeader = styled.div`
  display: flex;
  flex-direction: column;

  > .info {
    color: #f00;
    font-family: Pretendard;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  > .header {
    display: flex;
    justify-content: space-between;
    padding-top: 25px;
    font-family: Pretendard;
    font-size: 20px;
    font-weight: 600;
    text-align: left;

    > .sub {
      width: max-content;
      padding: 2.5px 10px;
      border-radius: 24px;
      background: #f00;
      color: #fff;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      line-height: normal;
    }
  }
`;

export const ManualPointContentWrapper = styled.div`
  position: relative;
  padding-bottom: 80px;
`;

export const ManualPointMemberWrapper = styled.div<{ isWide: boolean }>`
  width: ${(p) => (p.isWide ? "474px" : "100%")};
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 5px;

  > .box {
    display: flex;
    justify-content: space-between;
    font-family: Pretendard;
    font-size: 20px;
    font-weight: 600;

    > div {
      display: flex;
      gap: 10px;
      align-items: center;
    }

    .history {
      cursor: pointer;
      display: flex;
      padding: 4px 10px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 10px;
      background: #f0e8ff;
      color: #7f25fb;
      font-family: Pretendard;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: 18px; /* 150% */
    }
  }

  > .result {
    margin-top: 15px;
    justify-content: flex-end;
    display: flex;
    gap: 20px;
    font-family: Pretendard;
    font-size: 20px;
    font-weight: 600;
  }
`;

export const ManualPointInputWrapper = styled.div<{ isWide: boolean }>`
  display: flex;
  font-family: Pretendard;
  font-size: 20px;
  font-weight: 600;
  justify-content: space-between;
`;

export const ManualPointInputItem = styled.div<{ isWide: boolean }>`
  display: flex;
  gap: 25px;
  align-items: center;
  font-family: Pretendard;
  font-size: 14.67px;
  font-weight: 500;
  text-align: center;
  justify-content: space-between;

  > .memo {
    width: ${(p) => (p.isWide ? "68px" : "38px")};
    display: flex;
    justify-content: center;
    align-items: center;
  }

  > .memo-input {
    flex: 1;
    height: 34px;
    border-radius: 9.78px;
    border: 1px solid #e5e5e5;
    text-align: center;
    outline: none;
  }

  > input {
    width: ${(p) => (p.isWide ? "92px" : "74px")};
    height: 34px;
    border-radius: 9.78px;
    border: 1px solid #e5e5e5;
    text-align: center;
    outline: none;
    font-family: Pretendard;
  }
`;

export const ManualPointCumulativeWrapper = styled.div`
  display: flex;
  width: calc(100% - 30px);
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  border-radius: 8px;
  background: #e5e5e5;
  color: #000;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  span {
    color: #f00;
  }

  > .item {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
`;

export const ManualPointHistoryPageWrapper = styled.div`
  display: flex;
  gap: 15px;
  justify-content: center;
  align-items: center;

  > .page {
    font-family: Pretendard;
    font-weight: 700;
    font-size: 12px;
    text-align: center;
  }

  > img {
    cursor: pointer;
  }
`;

export const ManualPointHistoryWrapper = styled(MileagePopupWrapper)`
  width: 100%;
  height: 100%;
  z-index: 1010;
  border-radius: 13px;
  min-height: 322px;
`;

export const ManualPointHistoryTable = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  width: 100%;
  margin-bottom: 25px;

  > .header {
    display: flex;
    align-items: center;
    padding-bottom: 8px;
    border-bottom: 1.53px solid #b0b0b0;

    > .item {
      font-family: Pretendard;
      font-weight: 500;
      font-size: 11px;
      text-align: center;
      flex: 1;
    }
    > .back {
      width: 40px;
    }
  }

  > .body {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 17px;
    height: 212px;

    > .no-data {
      font-family: Pretendard;
      font-weight: 600;
      font-size: 12px;
      text-align: center;
    }
  }
`;

export const ManualPointHistoryItemWrapper = styled.div`
  display: flex;
  align-items: center;

  > .item {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 12px;
    text-align: center;
    flex: 1;
  }

  > .back {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 10px;
    text-align: left;
    text-decoration: underline;
    text-decoration-style: solid;
    color: #ff0000;
    width: 40px;
    cursor: pointer;
    text-align: center;
  }
`;

export const ManualPointHistoryHeader = styled(SolutionHistoryHeader)`
  > .right {
    display: flex;
    gap: 10px;
    align-items: center;

    > .name {
      display: flex;
      gap: 4px;
      align-items: center;
      font-family: Pretendard;
      font-weight: 400;
      font-size: 15px;

      > span {
        font-family: Pretendard;
        font-weight: 600;
        font-size: 20px;
      }
    }

    > .button {
      width: 86px;
      height: 31px;
      border-radius: 8px;
      background: #6436e7;
      font-family: Pretendard;
      font-weight: 600;
      font-size: 15px;
      line-height: 31px;
      text-align: center;
      color: #fff;
      cursor: pointer;
    }

    > img {
      width: 13.74px;
      height: 13.74px;
    }
  }

  img {
    cursor: pointer;
    margin-right: 10px;
  }
`;
